import { CommandResult } from '../amorg-common'
import { WorkgroupType } from '../amorg-common'
import { WorkgroupListing } from '../amorg-common'
import { apiPath } from "./adminClientApi";
import { queryAuthWrapper, commandAuthWrapper } from "./serverApiHelpers";

const workgroupsPath = `${apiPath}/workgroups`;

export const getWorkgroups = async (): Promise<WorkgroupListing[]> =>
    queryAuthWrapper(`${workgroupsPath}`);

export const createWorkgroup = async (id: string, name: string): Promise<CommandResult> =>
    commandAuthWrapper(`${workgroupsPath}`, 'POST',
        {
            id, name
        }
    );
export const updateWorkgroup = async (id: string, parentId: string, name: string, type: WorkgroupType): Promise<CommandResult> =>
    commandAuthWrapper(`${workgroupsPath}/${id}`, 'PUT',
        {
            parentId, name, type
        }
    );

export const addWorkgroupMember = async (workgroupId: string, userId: string): Promise<CommandResult> =>
    commandAuthWrapper(`${workgroupsPath}/${workgroupId}/member/${userId}`, 'POST');

export const removeWorkgroupMember = async (workgroupId: string, userId: string): Promise<CommandResult> =>
    commandAuthWrapper(`${workgroupsPath}/${workgroupId}/member/${userId}`, 'DELETE');

export const removeWorkgroup = async (workgroupId: string): Promise<CommandResult> =>
    commandAuthWrapper(`${workgroupsPath}/${workgroupId}`, 'DELETE');